import { ElementType } from 'react'

import { Text, TextProps } from '@lounge-fe/ui-kit/src/components/Text'

const defaultElement = 'h6'

const Subtitle = <E extends ElementType = typeof defaultElement>(
  props: TextProps<E>,
) =>
  props.children ? (
    <Text variant="title-four" as={defaultElement} {...props} />
  ) : null

export default Subtitle
